import { useImperativeHandle } from 'react';
import { useUpdateEffect } from 'react-use';

import { ExtendedDosageFormRenderProps } from '../../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm';
import { TemplatesFormProps } from '../../../../../shared/types';
import { DosageTemplateListItem } from '../DosageTemplates.types';

type UseDosageTemplateFormSynchronizationOptions = Pick<
   ExtendedDosageFormRenderProps,
   'formState' | 'watch' | 'control'
> &
   Pick<
      TemplatesFormProps<DosageTemplateListItem, never>,
      'onDirty' | 'onPristine' | 'onTemplateNameChange' | 'templatesApiRef'
   >;

export const useDosageTemplateFormSynchronization = (options: UseDosageTemplateFormSynchronizationOptions): void => {
   const { formState, watch, control, onDirty, onPristine, onTemplateNameChange, templatesApiRef } = options;
   const templateNameFieldRef = control.fieldsRef.current.templateName?.ref;
   const templateName = watch('templateName');

   useImperativeHandle(
      templatesApiRef,
      () => ({
         onActiveItemClick: () => {
            templateNameFieldRef?.focus?.();
         },
      }),
      [templateNameFieldRef]
   );

   useUpdateEffect(() => {
      templateNameFieldRef?.focus?.();
   }, [templateNameFieldRef]);

   useUpdateEffect(() => {
      if (formState.isDirty) {
         onDirty();
         return;
      }
      onPristine();
   }, [formState.isDirty]);

   useUpdateEffect(() => {
      onTemplateNameChange(templateName ?? '');
   }, [templateName]);
};
